import React from "react";
import { makeStyles, Box, Container } from "@material-ui/core";
import LoginContainer from "../containers/auth/LoginContainer";
import Page from "../components/Page";
import FooterView from "../views/auth/FooterView";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const renderFooterView = (type) => {
  switch (type) {
    case "installer":
      return <FooterView type={type} register={true} reset={true} />;
    case "customer":
      return <FooterView type={type} register={true} reset={true} />;
    case "admin":
      return <FooterView type={type} reset={false} />;
    default:
      return <FooterView register={true} reset={true} />;
  }
};

const LoginPage = () => {
  const classes = useStyles();
  let { type } = useParams();

  return (
    <Page className={classes.root} title="Ecat">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <LoginContainer type={type} />
          {renderFooterView(type)}
        </Container>
      </Box>
    </Page>
  );
};

export default LoginPage;
